import classes from "./Register.module.css";
import blueLogo from "../../images/blueLogo.svg";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { DownloadApp } from "./DownloadApp";
import { registerUser } from "../../redux/driver/thunks/registerDriverThunk";
import { validateToken } from "../../redux/driver/thunks/validateDriverInvitationThunk";
import { LoadingSpinner } from "../../components/loadingSpinner/LoadingSpinner";
import { BaseLoginInput } from "../../components/UI/baseLoginInput/BaseLoginInput";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { LanguageSwitcher } from "../../components/languageSwitcher/LanguageSwitcher";
import { resetRegisterState } from "../../redux/driver/slices/registerDriverSlice";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

export function Register() {
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.register);
  const validateTokenSelector = useSelector((state) => state.validateToken);
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslations();

  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    dispatch(resetRegisterState());
  }, []);

  useEffect(() => {
    if (status === "error") {
      setTimeout(() => {
        dispatch(resetRegisterState());
      }, 2000);
    }
  }, [status]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    const phonenumberParam = params.get("phonenumber");
    const tokenParam = params.get("token");

    if (emailParam) setEmail(emailParam);
    if (phonenumberParam) setPhonenumber(phonenumberParam);
    if (tokenParam) {
      setToken(tokenParam);
      dispatch(validateToken(tokenParam));
    } else {
      navigate("/login");
    }
  }, [location, dispatch, navigate]);

  useEffect(() => {
    if (
      validateTokenSelector.status === "error" &&
      validateTokenSelector.isValid === false
    ) {
      navigate("/login");
    }
  }, [validateTokenSelector, navigate]);

  function handlePhoneInput(e) {
    e.target.value = e.target.value.replace(/(?!^)\D/g, ""); // Allow only digits after the first character
    if (e.target.value[0] !== "+") {
      e.target.value = e.target.value.replace(/\D/g, ""); // Ensure the first character is "+"
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("token", token);
    dispatch(registerUser(Object.fromEntries(formData)));
  };

  const registerPage = t.registerPage;

  const isStatusLoading = status === "loading";

  const isBtnDisabled =
    isStatusLoading ||
    email === "" ||
    phonenumber === "" ||
    password === "" ||
    confirmPassword === "";

  const isStatusError = status === "error";

  return (
    <>
      {status === "success" ? (
        <section className={`${classes.registerContainer} fadeIn`}>
          <div className={classes.logo}>
            <div className={classes.box}></div>
            <div className={classes.overlay}></div>
          </div>
          <div className={classes.languageSwitcherContainer}>
            <LanguageSwitcher />
          </div>
          <form className={classes.registerForm} onSubmit={handleSubmit}>
            <div className={classes.formContent}>
              <img src={blueLogo} alt="Logo" />

              <div className={classes.inputs}>
                <BaseLoginInput
                  label={registerPage.form.firstname}
                  type={"text"}
                  name={"first_name"}
                />
                <BaseLoginInput
                  label={registerPage.form.lastname}
                  type={"text"}
                  name={"last_name"}
                />
                <BaseLoginInput
                  label={registerPage.form.email}
                  type={"email"}
                  name={"email"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <BaseLoginInput
                  label={registerPage.form.phone}
                  type={"tel"}
                  name={"phone_number"}
                  value={phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                  onInput={handlePhoneInput}
                />
                <BaseLoginInput
                  label={registerPage.form.password}
                  type={"password"}
                  name={"password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <BaseLoginInput
                  label={registerPage.form.confirmPassword}
                  type={"password"}
                  name={"confirm_password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <div className={classes.registerBtnContainer}>
                <ActionBtn
                  width={"100%"}
                  height={"50px"}
                  type="submit"
                  disabled={isBtnDisabled}
                  text={
                    isStatusLoading ? (
                      <LoadingSpinner />
                    ) : (
                      registerPage.registerBtn
                    )
                  }
                />
              </div>

              <div
                className={classes.errorMsg}
                style={{
                  opacity: isStatusError ? 1 : 0,
                  pointerEvents: isStatusError ? "auto" : "none",
                }}
              >
                {error}
              </div>
            </div>
          </form>
        </section>
      ) : (
        <DownloadApp />
      )}
    </>
  );
}
